<template>
  <div class="small-city-code container">

    <div class="row justify-content-center mt-3">
      <div class="city-title">家庭住宅短效代理城市列表</div>
    </div>

    <div class="row">

      <b-table :striped="true"
               :bordered="true"
               :fixed="true"
               :fields="tableData.fields"
               :items="citys"
      ></b-table>

    </div>

  </div>
</template>

<script>
import { provinceAndCityData } from '@/utils/small_city'
export default {
  data() {
    return {
      citys: null,
      tableData: {
        fields: [
          {
            key: 'province',
            label: '省份',
          },
          {
            key: 'province_code',
            label: '省份代码',
          },
          {
            key: 'city',
            label: '城市',

          },
          {
            key: 'city_code',
            label: '城市代码',
          },
        ],
      },
    }
  },
  mounted() {
    let a = []
    let k = 0
    for (let i of provinceAndCityData) {
      let cck = 0
      for (let j of i.children) {
        a[k] = {
          province: i.label,
          province_code: i.value,
          city: j.label,
          city_code: j.value,
          count: i.children.length,
          key: cck,
        }
        cck++
        k++
      }
    }
    this.citys = a
  }
}
</script>

<style lang="less" scoped>

  .small-city-code {
    .city-title {
      font-size: 23px;
    }
  }

</style>